<template>
  <div>
    <b-card title="Pacote">
      <b-button
        class="btn-sm btn-nav-link btn-nav-link-white"
        size="sm"
        variant="flat-primary"
        :to="{ name: 'admin-package-register' }"
      >
        <feather-icon icon="PlusIcon" />
        Adicionar
      </b-button>
      <b-button
      class="btn-sm btn-nav-link btn-nav-link-white"
      size="sm"
      variant="flat-primary"
      @click="reportData"
    >
      <feather-icon icon="FileTextIcon" />
      Exportar
    </b-button>
      <custom-g-table
        v-if="displayTable"
        :displayLoading="tableLoading"
        :fields="fields"
        :items="data"
        :hasEditButton="true"
        :hasDeleteButton="false"
        :totalRows="totalRows"
        :limit="limit"
        @changePage="onChangePage"
        @onEdit="onEdit"
        @onDelete="onDelete"
        @onSortChange="onSortChange"
        @onColumnFilter="onFilter"
      />
    </b-card>
  </div>
</template>

<script>
import { BButton, BCard } from "bootstrap-vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import packageService from "@/providers/packageService";
import AppConstants from "@/appConstants";
// import CustomFilter from "@/views/custom/table/CustomFilter.vue";
import dropdownService from '@/providers/dropdownService';
import messageDialogHelper from '@/helpers/message-dialog-helper';
import { setRouteQuery, buildParamsRouteQuery } from "@/helpers/route-query-helper";
import { onlyLatestRequest } from "@/helpers/latest-request-helper";

export default {
  props: {
    urlQuery: Object
  },
  components: {
    BCard,
    BButton,
    CustomGTable,
    // CustomFilter
  },
  data() {
    return {
      displayTable: false,
      sortField: {},
      data: [],
      origins: [],
      totalRows: 0,
      limit: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      page: 1,
      filter: {},
      tableLoading: true,
      fields: [
        { field: "name", label: "Nome", sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por nome', trigger: 'enter' } },
        { field: "code", label: "Código", sortable: true, filterOptions: { filterValue: '', enabled: true, numeric: true, placeholder: 'Pesquisar por código', trigger: 'enter' } },
        { field: "origin", label: "Origem", type: "object", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por origem', filterDropdownItems: [] } },
        { field: "dt_create", label: "Criação", type: "custom_date", sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por data', trigger: 'enter' } },
        { field: "active", label: "Habilitado", type: "boolean", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por ativo', filterDropdownItems: [{value: true, text: 'Sim'}, {value: false, text: 'Não'}] } },
        { field: "action_buttons", label: "Ações", sortable: false },
      ],
    };
  },
  mounted() {
    this.$store.dispatch("admin/updatePageTitle", 'Pacote');
    this.loadDataFilter();
  },
  computed: {
    searchParams() {
      const params = buildParamsRouteQuery(this.$route.query);
      params.append('page', this.page);
      params.append('limit', this.limit);
      if (this.sortField.field) {
        params.append(`sort_${this.sortField.field}`, this.sortField.type);
      }
      return params;
    },
  },
  methods: {
    setInitialTableFilters() {
      Object.keys(this.urlQuery).forEach(item => {
        this.fields[this.fields.findIndex(val => val.field==item)].filterOptions.filterValue = this.urlQuery[item];
      });
      this.loadData();
    },
    reportData() {
      const params = this.searchParams;
      params.append("download", true);
      packageService
        .report(params)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", 'pacotes.xlsx');
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((err) => console.log(err));
    },
    onChangePage(page) {
      this.page = page;
      this.loadData();
    },
    onFilter(data) {
      // this.filter = data;
      // console.log('OnFilter: ', this.filter);
      setRouteQuery(data, this.$route.query);
      this.loadData();
    },
    loadDataFilter() {
      dropdownService.getAllOrigin(new URLSearchParams())
      .then(res => {
        const origins = res.map(item => {
          return { value: item.id, text: item.name };
        });
        this.fields[this.fields.findIndex(item => item.field=='origin')].filterOptions.filterDropdownItems = origins;
        this.setInitialTableFilters();
      })
      .catch(err => console.log(err));
    },
    onEdit(data) {
      this.$router.push(
        `${AppConstants.NAVIGATION_PAGE_ADM_PACKAGE_REGISTER}/${data._id}`
      );
    },
    onDelete(data) {
      // console.log(data);
      const params = new URLSearchParams();
      packageService
        .deletePackage(data._id, params)
        .then(() => {
          console.log("deleted");
          messageDialogHelper.displayDeleteDataMessage(()=> {
            this.loadData();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadData() {
      this.tableLoading = true;
      onlyLatestRequest(this, 'loadData', packageService.getAllPackage(this.searchParams))
        .then((res) => {
          this.displayTable = true;
          this.tableLoading = false;
          this.data = res.data;
          this.totalRows = res.totalRows;
        })
        .catch((err) => {
          this.displayTable = true;
          console.log(err);
        });
    },
    onSortChange(params) {
      this.sortField = params;
      this.loadData();
    },
  },
};
</script>

<style>
</style>